import { render, staticRenderFns } from "./advLossLevel.vue?vue&type=template&id=24be05eb&"
import script from "./advLossLevel.vue?vue&type=script&lang=js&"
export * from "./advLossLevel.vue?vue&type=script&lang=js&"
import style0 from "./advLossLevel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24be05eb')) {
      api.createRecord('24be05eb', component.options)
    } else {
      api.reload('24be05eb', component.options)
    }
    module.hot.accept("./advLossLevel.vue?vue&type=template&id=24be05eb&", function () {
      api.rerender('24be05eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/advLossLevel.vue"
export default component.exports